import { cva, type VariantProps } from "class-variance-authority";

// Пункт меню: первый ребёнок — значок или иконка героя, остальное — подписи. В свёрнутом
// меню подписи видны только экранному диктору, остаётся квадрат со значком. Выбранный
// пункт — `data-active` или `data-status="active"`, который ставит `Link` роутера.
export const sidebarMenuButtonVariants = cva(
  "flex w-full min-w-0 items-center gap-3 overflow-hidden rounded-lg px-2.5 text-left text-[15px] no-underline transition-colors outline-none group-data-[state=collapsed]/sidebar:justify-center group-data-[state=collapsed]/sidebar:px-0 hover:bg-sidebar-active/60 focus-visible:ring-2 focus-visible:ring-accent/60 disabled:pointer-events-none disabled:opacity-50 data-[active=true]:bg-sidebar-active data-[status=active]:bg-sidebar-active group-data-[state=collapsed]/sidebar:[&>:not(:first-child)]:sr-only [&>svg]:size-5.5 [&>svg]:shrink-0 [&>svg]:text-subtle data-[active=true]:[&>svg]:text-accent data-[status=active]:[&>svg]:text-accent",
  {
    variants: {
      size: {
        default:
          "min-h-11 text-muted group-data-[state=collapsed]/sidebar:size-12 hover:text-foreground data-[active=true]:font-semibold data-[active=true]:text-foreground data-[status=active]:font-semibold data-[status=active]:text-foreground",
        // Строка с картинкой и двумя строками текста (матч, игрок). Выбранная — только фоном:
        // жирный шрифт перенёс бы подписи.
        lg: "min-h-12 py-1.5 text-foreground ring-accent ring-inset group-data-[state=collapsed]/sidebar:size-11 group-data-[state=collapsed]/sidebar:data-[active=true]:ring-2 group-data-[state=collapsed]/sidebar:data-[status=active]:ring-2",
      },
    },
    defaultVariants: {
      size: "default",
    },
  },
);

export type SidebarMenuButtonVariantProps = VariantProps<typeof sidebarMenuButtonVariants>;
